/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GiftCardResponse model module.
 * @module model/GiftCardResponse
 * @version v1
 */
class GiftCardResponse {
    /**
     * Constructs a new <code>GiftCardResponse</code>.
     * @alias module:model/GiftCardResponse
     * @param giftCardNum {String} MaxLength:25
     * @param giftCardSecurityCode {String} MaxLength:5
     * @param amount {Number} 
     * @param idempotencyStatus {String} MaxLength:15
     */
    constructor(giftCardNum, giftCardSecurityCode, amount, idempotencyStatus) { 
        
        GiftCardResponse.initialize(this, giftCardNum, giftCardSecurityCode, amount, idempotencyStatus);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, giftCardNum, giftCardSecurityCode, amount, idempotencyStatus) { 
        obj['GiftCardNum'] = giftCardNum;
        obj['GiftCardSecurityCode'] = giftCardSecurityCode;
        obj['Amount'] = amount;
        obj['IdempotencyStatus'] = idempotencyStatus;
    }

    /**
     * Constructs a <code>GiftCardResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GiftCardResponse} obj Optional instance to populate.
     * @return {module:model/GiftCardResponse} The populated <code>GiftCardResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GiftCardResponse();

            if (data.hasOwnProperty('GiftCardNum')) {
                obj['GiftCardNum'] = ApiClient.convertToType(data['GiftCardNum'], 'String');
            }
            if (data.hasOwnProperty('GiftCardSecurityCode')) {
                obj['GiftCardSecurityCode'] = ApiClient.convertToType(data['GiftCardSecurityCode'], 'String');
            }
            if (data.hasOwnProperty('Amount')) {
                obj['Amount'] = ApiClient.convertToType(data['Amount'], 'Number');
            }
            if (data.hasOwnProperty('IdempotencyStatus')) {
                obj['IdempotencyStatus'] = ApiClient.convertToType(data['IdempotencyStatus'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GiftCardResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GiftCardResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of GiftCardResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['GiftCardNum'] && !(typeof data['GiftCardNum'] === 'string' || data['GiftCardNum'] instanceof String)) {
            throw new Error("Expected the field `GiftCardNum` to be a primitive type in the JSON string but got " + data['GiftCardNum']);
        }
        // ensure the json data is a string
        if (data['GiftCardSecurityCode'] && !(typeof data['GiftCardSecurityCode'] === 'string' || data['GiftCardSecurityCode'] instanceof String)) {
            throw new Error("Expected the field `GiftCardSecurityCode` to be a primitive type in the JSON string but got " + data['GiftCardSecurityCode']);
        }
        // ensure the json data is a string
        if (data['IdempotencyStatus'] && !(typeof data['IdempotencyStatus'] === 'string' || data['IdempotencyStatus'] instanceof String)) {
            throw new Error("Expected the field `IdempotencyStatus` to be a primitive type in the JSON string but got " + data['IdempotencyStatus']);
        }

        return true;
    }


}

GiftCardResponse.RequiredProperties = ["GiftCardNum", "GiftCardSecurityCode", "Amount", "IdempotencyStatus"];

/**
 * MaxLength:25
 * @member {String} GiftCardNum
 */
GiftCardResponse.prototype['GiftCardNum'] = undefined;

/**
 * MaxLength:5
 * @member {String} GiftCardSecurityCode
 */
GiftCardResponse.prototype['GiftCardSecurityCode'] = undefined;

/**
 * @member {Number} Amount
 */
GiftCardResponse.prototype['Amount'] = undefined;

/**
 * MaxLength:15
 * @member {String} IdempotencyStatus
 */
GiftCardResponse.prototype['IdempotencyStatus'] = undefined;






export default GiftCardResponse;

